export const filelist2 = [
    {
        value: "Informationsschreiben",
        link: "/protocols/20250523/1_Informationsschreiben.pdf"
    },
    {
        value: "Sessionsprotokoll",
        link: "/protocols/20250523/2_Sessionsprotokoll.pdf"
    },
    {
        value: "Strategie definitiv",
        link: "/protocols/20250523/3_Strategie_definitiv_2025-07-02.pdf"
    },
]